import { render } from "./DetailsHeader.vue?vue&type=template&id=6568e529"
import script from "./DetailsHeader.vue?vue&type=script&lang=js"
export * from "./DetailsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__